import { Link, useLocation } from 'react-router-dom';
import { Offcanvas, Nav } from 'react-bootstrap';
import { getNavLinks } from '../navLinks';
import ActiveUnitSelector from '../ActiveUnitSelector/ActiveUnitSelector';
import './Sidebar.css';

const Sidebar = ({ show, handleClose }) => {

    const location = useLocation();

    const user = JSON.parse(localStorage.getItem("user")) || {};
    const cooperative = JSON.parse(localStorage.getItem("units")) || [JSON.parse(localStorage.getItem("cooperative"))] || [];

    const navLinks = getNavLinks(user, cooperative);

    return (
        <Offcanvas
            show={show}
            onHide={handleClose}
            placement="start"
            className="sgu-mobile-sidebar"
            style={{
                background: "var(--sgu-nav-bg)",
                color: "var(--sgu-nav-text)",
                width: "min(280px, 92vw)"
            }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                    {user?.name || "Usuário"}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <ActiveUnitSelector dark onUnitChanged={handleClose} />
                <Nav className="flex-column">
                    {navLinks
                        .filter(link => link.permission)
                        .map((link, index) => (
                            <Nav.Item key={index} className="my-2">
                                <Link
                                    to={link.path}
                                    className={`nav-link d-flex align-items-center px-3 py-2 rounded ${location.pathname === link.path
                                        ? "sgu-mobile-sidebar__link--active"
                                        : ""
                                        }`}
                                    style={{
                                        color: "var(--sgu-nav-text)",
                                    }}
                                    onClick={handleClose}
                                >
                                    <span style={{ marginRight: "10px", fontSize: "1.2rem" }}>
                                        {link.icon}
                                    </span>
                                    {link.label}
                                </Link>
                            </Nav.Item>
                        ))}
                </Nav>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default Sidebar;
